<template>
  <div
    class="content-block products-block"
    data-aos="fade-up"
    data-aos-duration="800"
    data-aos-delay="200"
    id="products"
    ref="productsSection"
  >
    <div class="block-left">
      <div class="block-number">05</div>
      <BlockHeader
        title="产品类目"
        subtitle="味承经典，品呈多元"
        subtitleEn="PRODUCT CATEGORIES"
      />
      <div class="block-ornament">
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
      </div>
    </div>
    <div class="block-right">
      <div class="categories-container">
        <div class="category-card" :style="{ '--delay': '0.1s' }">
          <div class="category-image">
            <img
              :src="getImageUrl('4.jpg')"
              alt="牛肉干系列"
              class="category-img"
            />
            <div class="image-overlay"></div>
          </div>
          <h4>经典主打</h4>
          <div class="category-subtitle">牛肉干系列</div>
          <p>精选优质牛肉，传统工艺制作，肉质鲜嫩，口感醇厚</p>
          <div class="category-tags">
            <span class="tag">五香</span>
            <span class="tag">麻辣</span>
            <span class="tag">手撕</span>
          </div>
          <router-link
            :to="{ name: 'ProductDetail', params: { id: 'beef-jerky' } }"
            class="category-btn"
          >
            <span>查看系列</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

        <div class="category-card" :style="{ '--delay': '0.2s' }">
          <div class="category-image">
            <img
              :src="getImageUrl('1.jpg')"
              alt="猪肉脯系列"
              class="category-img"
            />
            <div class="image-overlay"></div>
          </div>
          <h4>风情肉脯</h4>
          <div class="category-subtitle">猪肉脯系列</div>
          <p>精选优质猪肉，薄如蝉翼，色泽红润，甜咸适口</p>
          <div class="category-tags">
            <span class="tag">原味</span>
            <span class="tag">蜜汁</span>
            <span class="tag">香辣</span>
          </div>
          <router-link
            :to="{ name: 'ProductDetail', params: { id: 'pork-jerky' } }"
            class="category-btn"
          >
            <span>查看系列</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

        <div class="category-card" :style="{ '--delay': '0.3s' }">
          <div class="category-image">
            <img
              :src="getImageUrl('5.jpg')"
              alt="休闲零食系列"
              class="category-img"
            />
            <div class="image-overlay"></div>
          </div>
          <h4>闲情小食</h4>
          <div class="category-subtitle">休闲零食系列</div>
          <p>各式精美小食，满足不同口味，休闲时刻的最佳伴侣</p>
          <div class="category-tags">
            <span class="tag">坚果</span>
            <span class="tag">果干</span>
            <span class="tag">糕点</span>
          </div>
          <router-link
            :to="{ name: 'ProductDetail', params: { id: 'snacks' } }"
            class="category-btn"
          >
            <span>查看系列</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

        <div class="category-card" :style="{ '--delay': '0.4s' }">
          <div class="category-image">
            <img
              :src="getImageUrl('6.jpg')"
              alt="腰果系列"
              class="category-img"
            />
            <div class="image-overlay"></div>
          </div>
          <h4>自然臻选</h4>
          <div class="category-subtitle">坚果系列</div>
          <p>精选优质腰果，颗颗饱满，香脆可口，营养丰富</p>
          <div class="category-tags">
            <span class="tag">原味</span>
            <span class="tag">盐焗</span>
            <span class="tag">蜂蜜</span>
          </div>
          <router-link
            :to="{ name: 'ProductDetail', params: { id: 'cashew' } }"
            class="category-btn"
          >
            <span>查看系列</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

        <div class="category-card" :style="{ '--delay': '0.5s' }">
          <div class="category-image">
            <img
              :src="getImageUrl('2.jpg')"
              alt="礼盒系列"
              class="category-img"
            />
            <div class="image-overlay"></div>
          </div>
          <h4>国民礼遇</h4>
          <div class="category-subtitle">礼盒系列</div>
          <p>精美包装设计，搭配经典产品，送礼佳品，体面大方</p>
          <div class="category-tags">
            <span class="tag">佳节</span>
            <span class="tag">商务</span>
            <span class="tag">定制</span>
          </div>
          <router-link
            :to="{ name: 'ProductDetail', params: { id: 'gift-box' } }"
            class="category-btn"
          >
            <span>查看系列</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

        <div class="category-card" :style="{ '--delay': '0.6s' }">
          <div class="category-image">
            <img
              :src="getImageUrl('3.jpg')"
              alt="文创系列"
              class="category-img"
            />
            <div class="image-overlay"></div>
          </div>
          <h4>国民文创</h4>
          <div class="category-subtitle">文创系列</div>
          <p>融合文化创意，独特设计包装，传递品牌文化价值</p>
          <div class="category-tags">
            <span class="tag">设计感</span>
            <span class="tag">文化</span>
            <span class="tag">收藏</span>
          </div>
          <router-link
            :to="{ name: 'ProductDetail', params: { id: 'cultural' } }"
            class="category-btn"
          >
            <span>查看系列</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockHeader from "../common/BlockHeader.vue";

export default {
  components: { BlockHeader },
  name: "ProductsBlock",
  methods: {
    getImageUrl(imageName) {
      return require(`@/assets/product/${imageName}`);
    },
  },
};
</script>

<style scoped>
.products-block {
  display: flex;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 15px;
  margin-bottom: 40px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.products-block:hover {
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 15px 35px rgba(154, 27, 30, 0.12);
}

.products-block .block-left {
  flex: 0 0 280px;
  padding: 35px 25px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.05), transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(154, 27, 30, 0.1);
}

.products-block .block-number {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 3.5rem;
  font-weight: 900;
  color: rgba(154, 27, 30, 0.05);
  z-index: 0;
}

.products-block .block-ornament {
  position: absolute;
  bottom: 25px;
  display: flex;
  gap: 6px;
}

.products-block .ornament-item {
  width: 3px;
  height: 18px;
  background: linear-gradient(to top, #9a1b1e, transparent);
  border-radius: 1.5px;
}

.products-block .ornament-item:nth-child(2) {
  height: 24px;
  background: linear-gradient(to top, #b22222, transparent);
}

.products-block .ornament-item:nth-child(3) {
  height: 20px;
  background: linear-gradient(to top, #d32f2f, transparent);
}

.products-block .block-right {
  flex: 1;
  padding: 35px 30px;
  position: relative;
  z-index: 1;
}

.products-block .block-content {
  margin-bottom: 25px;
}

.products-block .block-desc {
  font-size: 1rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 25px;
}

.products-block .categories-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  margin: 25px 0;
}

.products-block .category-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  transition: all 0.4s;
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: var(--delay);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.03);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.products-block .category-card:hover {
  background: rgba(154, 27, 30, 0.02);
  border-color: rgba(154, 27, 30, 0.3);
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(154, 27, 30, 0.1);
}

.products-block .category-image {
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s;
  border: 1px solid rgba(154, 27, 30, 0.1);
}

.products-block .category-card:hover .category-image {
  transform: scale(1.03);
  border-color: rgba(154, 27, 30, 0.3);
}

.products-block .category-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s;
}

.products-block .category-card:hover .category-img {
  transform: scale(1.1);
}

.products-block .image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(154, 27, 30, 0.05),
    rgba(0, 0, 0, 0.1)
  );
  pointer-events: none;
}

.products-block .category-card h4 {
  font-size: 1.4rem;
  color: #9a1b1e;
  font-weight: 700;
  text-align: center;
  position: relative;
  display: inline-block;
  margin: 5px auto;
}

.products-block .category-card h4::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 2px;
  background: #9a1b1e;
  border-radius: 1px;
}

.products-block .category-subtitle {
  font-size: 1.1rem;
  color: #222;
  margin-bottom: 15px;
  font-weight: 600;
  text-align: center;
}

.products-block .category-card p {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
  text-align: center;
  flex: 1;
}

.products-block .category-tags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 25px;
}

.products-block .tag {
  font-size: 0.75rem;
  color: #9a1b1e;
  background: rgba(154, 27, 30, 0.08);
  padding: 4px 12px;
  border-radius: 15px;
  border: 1px solid rgba(154, 27, 30, 0.2);
  white-space: nowrap;
  transition: all 0.3s;
  font-weight: 500;
}

.products-block .category-card:hover .tag {
  background: rgba(154, 27, 30, 0.15);
  transform: translateY(-2px);
  border-color: rgba(154, 27, 30, 0.4);
}

.products-block .category-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(154, 27, 30, 0.08);
  color: #9a1b1e !important;
  padding: 12px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  border: 1px solid rgba(154, 27, 30, 0.2);
  position: relative;
  overflow: hidden;
  margin-top: auto;
}

.products-block .category-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(154, 27, 30, 0.1),
    transparent
  );
  transition: left 0.5s;
}

.products-block .category-btn:hover {
  background: rgba(154, 27, 30, 0.15);
  border-color: #9a1b1e;
  color: #9a1b1e !important;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(154, 27, 30, 0.15);
  text-decoration: none;
}

.products-block .category-btn:hover::before {
  left: 100%;
}

.products-block .category-btn i {
  transition: transform 0.3s;
  font-size: 1rem;
}

.products-block .category-btn:hover i {
  transform: translateX(5px);
}

.products-block .category-btn span {
  position: relative;
  z-index: 1;
  font-weight: 600;
}

@media (max-width: 1200px) {
  .products-block .block-left {
    flex: 0 0 250px;
  }

  .products-block .categories-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .products-block {
    flex-direction: column;
  }

  .products-block .block-left {
    flex: 0 0 auto;
    padding: 30px 25px;
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
  }

  .products-block .block-right {
    padding: 30px 25px;
  }

  .products-block .categories-container {
    grid-template-columns: repeat(2, 1fr);
  }

  .products-block .category-image {
    height: 180px;
  }
}

@media (max-width: 768px) {
  .products-block .block-left {
    padding: 25px 20px;
  }

  .products-block .block-right {
    padding: 25px 20px;
  }

  .products-block .block-title {
    font-size: 1.6rem;
  }

  .products-block .categories-container {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .products-block .category-image {
    height: 220px;
  }

  .products-block .category-btn {
    padding: 14px 20px;
  }
}

@media (max-width: 576px) {
  .products-block .category-image {
    height: 200px;
  }

  .products-block .category-card h4 {
    font-size: 1.3rem;
  }

  .products-block .category-subtitle {
    font-size: 1rem;
  }

  .products-block .category-btn {
    padding: 12px 18px;
  }
}

.products-block::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(154, 27, 30, 0.03) 0%,
    transparent 70%
  );
  z-index: 0;
}

.products-block > * {
  position: relative;
  z-index: 1;
}

.products-block .category-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.02), transparent);
  z-index: 0;
  pointer-events: none;
}

.products-block .category-card > * {
  position: relative;
  z-index: 1;
}
</style>
